import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { mapState, mapActions } from 'vuex';
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      optionsoRganization: [],
      formData: {
        id: "",
        password: "",
        status: 1,
        sub_dev: ""
      },
      userList: [],
      enterpriseList: [],
      rules: {
        status: [{
          required: true,
          message: "请选择用户状态",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // let roleList = await this.$api.userAddList({ id: 't' })
                // this.optionsoRganization = roleList.data
                _this.copyPrimitive();

                _this.getUserList(id);

                if (!id) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.$api.userDetails({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this.formData = _objectSpread({}, res.data.admin_info);
                    _this.formData.sub_dev = _this.formData.sub_dev != 0 ? _this.formData.sub_dev : '';
                  }
                });

              case 5:
                _this.copyData();

                _this.dialogFormVisible = true;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getUserList: function getUserList(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.subUserList({
                  page: 1,
                  page_size: -1,
                  enterprise_id: _this2.info.enterprise.id,
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    //let name = this.$store.state.d2admin.user.info.name
                    _this2.userList = res.data.filter(function (item) {
                      return item.id != id;
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this3.formData.id == '' ? 'userAdd' : 'userUpd';
                    _this3.formData.sub_dev = _this3.formData.sub_dev ? _this3.formData.sub_dev : 0;

                    _this3.$api[reqFn](_this3.formData).then(function (res) {
                      if (res.status == 200) {
                        _this3.$message.success(_this3.formData.id == '' ? '添加成功' : '修改成功');

                        _this3.$emit('change');

                        _this3.dialogFormVisible = false;
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};